<script setup lang="ts">
type GarlicProps = {
  isOutline: boolean
  styles: {
    top: string
    left: string
    transform: string
    position: 'absolute' | 'fixed'
  }
  color?: string
}

const props = defineProps<GarlicProps>()

const getColor = (defaultColor: string) => {
  return props.color ? props.color : defaultColor
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 369.49 234.42"
    :style="styles"
    class="-z-1 h-[25vh] w-[25vh] overflow-hidden"
  >
    <g id="a" />
    <g id="b" />
    <g id="c" />
    <g id="d" />
    <g id="e" />
    <g id="f" />
    <g id="g" />
    <g id="h">
      <path
        class="u"
        :fill="getColor('#efd7a0')"
        :fill-opacity="isOutline ? 0 : 1"
        :stroke-width="isOutline ? 10 : 0"
        stroke="#FFFFFF"
        d="M74.16,192.32c-18.24-12.31-36.32-24.89-50.8-40.85-19.58-21.58-10.59-37.56-8.67-63.8,2.27-31.11,28.53-27.77,54.53-31.94,32.07-5.14,64.18-13.63,93.89-25.96,14.85-6.16,29.51-13.75,45.26-17.73,15.48-3.92,32.5-2.39,48.33-1.88,27.52,.89,47.45,5.52,71.33,19.6,8.35,4.93,22.11,9.42,28.38,16.01,8.08,8.49,1.9,17.54,.71,29.08-3.82,36.91-27.9,72.26-54.59,97.31-58.09,54.5-151.67,70.87-228.36,20.17Z"
      />
    </g>
    <g id="i" />
    <g id="j">
      <g id="k" />
      <g id="l" />
      <g id="m" />
      <g id="n" />
      <g id="o" />
      <g id="p" />
      <g id="q" />
      <g id="r" />
      <g id="s" />
      <g id="t" />
    </g>
  </svg>
</template>

<style scoped></style>
